import React, { Component } from 'react'
import moment from 'moment'
import Media from 'react-bootstrap/Media'
import ReactMarkdown from 'react-markdown'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'


class ContentsCard extends Component {
  renderTaskDetail(task) {
    if (!task.data || !task.data.data) {
      return ''
    }
    const pattern = /^!([^#]+)(#.+)?$/
    const rows = (JSON.parse(task.data.data).rows || [])
    const imageRows = rows.filter(row => row.length > 0 && row[0].match(pattern)).map(row => row[0].match(pattern)[1])
    if (imageRows.length === 0) {
      return `${rows.length} 文`
    }
    const pages = []
    imageRows.forEach(imageRow => {
      if (pages.includes(imageRow)) {
        return
      }
      pages.push(imageRow)
    })
    return `${pages.length} ページ`
  }

  render() {
    const { task } = this.props
    const url = `${this.props.baseURL}/?task_id=${task.id}&v2=1`
    return <Media className='ContentsMedia'>
      {task.thumbnail && <a href={url}>
          <img alt='thumbnail' src={task.thumbnail} />
        </a>}
      <Media.Body className='ContentsCard'>
        <h5>
          {task.data ? task.data.title : task.id}
        </h5>
        {task.data && task.data.description && <ReactMarkdown>
            {task.data.description.split('\n')[0]}
          </ReactMarkdown>}
        {!task.data &&
          <div className='InvalidTask'>タスクが見つかりません: {task.id}</div>}
        <div className='TaskDetail'>
          {this.renderTaskDetail(task)}
          <span className='ProgressBadge'>
            {task.record ?
              (task.record.completed ? <Badge variant='success'>完了</Badge> : <Badge variant='danger'>{parseInt(task.record.rate * 100)} %</Badge>) :
              <Badge variant='danger'>未実施</Badge>}
          </span>
          <span className='ContentsUpdated'>
            {task.data ? `最終更新: ${moment(new Date(task.data.updated)).fromNow()}` : '削除済み'}
          </span>
          <span className='ContentsAccess'>
            {task.record && `アクセス: ${moment(new Date(task.record.accessed)).fromNow()}`}
          </span>
        </div>
        {task.data && <div className='ContentsStartButton'>
            <Button variant="primary" href={url}>はじめる</Button>
          </div>}
      </Media.Body>
    </Media>
  }
}

export default ContentsCard;
